import React from 'react'
import { Image } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import CreditCardBrandsImage from '@images/external_payment/credit_card_brands.webp'

export const CreditCardOption = () => (
  <Image w="212px" h="23px" src={buildAssetUrlString(CreditCardBrandsImage)} alt="VISA, Mastercard, JCB, Discover, Diners, AMEX" objectFit="contain" />
)
